import React, { Component } from 'react';
import { Header } from 'semantic-ui-react';

class Hero extends Component {
  constructor (props) {
    super(props);
    this.state = {
      animation: (localStorage.getItem('bannerAnimation') === null) ? 'run-animation' : 'disable-animation',
    };
  }

  componentDidMount () {
    this.animateBanner();
  }

  componentWillReceiveProps (nextProps) {
    this.animateBanner();
  }

  animateBanner () {
    setTimeout(() => {
      localStorage.setItem('bannerAnimation', false);
    }, 4000);
  }

  render () {
    return (
      <div className="hero full-width">
        <div className="wrapper">
          <div className="container">
            <p className="subtitle-above">
              For eligible patients with commercial insurance*
            </p>
            <Header as="h1">
              Takeda Oncology <br /> <strong className="poppins-bold">Co-Pay Assistance Program</strong>
              <Header.Subheader>
                <p>You could pay as little as $0 per prescription<sup>&dagger;</sup></p>
              </Header.Subheader>
            </Header>
            <p className="concerned">
              <strong>Concerned about paying for your Takeda Oncology treatment?</strong> Takeda Oncology Here2Assist&reg; is here to help patients throughout their treatment. If there is a concern about the cost of treatment, the Takeda Oncology Co-Pay Assistance Program<sup>&dagger;</sup> may be able to help reduce patients&prime; out-of-pocket costs associated with their medication.
            </p>
          </div>
        </div>
        <div className="patient">
          <img src="/images/takeda_co-pay_homepage-image.png" alt="Active senior man with white hair and beard in casual jacket looking upward outdoors, framed by modern abstract design elements. Models are used for illustrative purposes only." />
        </div>
      </div>
    );
  }
}

export default Hero;
